import React from 'react';
import Seo from '$components/Seo';
import ReviewWrapper from './ReviewWrapper';

const Review = (props) => {
  const { history, match } = props;

  return (
    <>
      <Seo title="Review" canonical={null} description={null} />
      <ReviewWrapper history={history} match={match} mode="review" />
    </>
  );
};

export default Review;
